import { Component, OnInit } from '@angular/core';
import { isJsonString } from '../../shared/utils/common';
import { MSG_CONTENT_TYPE, _MSGTYPES } from '../../shared/constant/msgType';
import { URLS } from '../../shared/constant/interface';
import { NzModalRef } from 'ng-zorro-antd';

@Component({
  selector: 'icc-tiktok-modal-detail',
  templateUrl: './tiktok-modal-detail.component.html',
  styles: [],
})
export class TiktokModalDetailComponent implements OnInit {
  constructor(private modal: NzModalRef) {}
  SCENE = 'icc-msg-modal-detail';
  type = _MSGTYPES.MT.TIKTOK.type;
  isMo: boolean;
  title: string;
  content: any;
  moContent: any;
  mtContent: any;
  contentType: number;
  name: string;

  // 地址前缀
  baseUrl = URLS.attachment.url + '?';
  contentTypes = MSG_CONTENT_TYPE;

  ngOnInit() {
    if (this.isMo) {
      this.contentType = this.contentTypes.TEXT;
      this.content = this.moContent || '【抖音私信内容为空】';
    } else {
      if (isJsonString(this.mtContent)) {
        const _jsonContent = JSON.parse(this.mtContent);
        let jsonContent = _jsonContent;
        if (jsonContent instanceof Array && jsonContent.length) {
          jsonContent = _jsonContent[0];
        }

        this.contentType = jsonContent.contentType;
        switch (jsonContent.contentType) {
          case this.contentTypes.IMAGE:
            const imgList = [];
            const tempArr = jsonContent.mediaList;
            if (tempArr instanceof Array) {
              tempArr.forEach(imgItem => {
                imgList.push({
                  name: imgItem.name,
                  url: this.baseUrl + imgItem.url,
                });
              });
            }
            this.content = imgList;
            break;
          case this.contentTypes.VIDEO:
            this.content = this.baseUrl + jsonContent.mediaList[0].url;
            this.name = jsonContent.mediaList[0].name;
            break;
          default:
            if ('text' === jsonContent.messageType) {
              this.content = jsonContent.content ? jsonContent.content.text : '';
              this.contentType = this.contentTypes.TEXT;
            }
            break;
        }
      }
    }
  }
  closeModel() {
    this.modal.close();
  }
}
